<template>
  <div class="account_recharge">
    <h1 class="mb20">当前账户余额：{{accountMsg.AgentBalance}}元</h1>

    <ul class="exchange_recharge mb20 ml30">
      <li :class="{'active' : alipayType === 'automaticRecharge'}" @click="exchangeAlipayType('automaticRecharge')">支付宝自动充值</li>
      <li :class="{'active' : alipayType === 'manualRecharge'}" @click="exchangeAlipayType('manualRecharge')">银行卡手动充值</li>
    </ul>
    <div v-if="alipayType === 'automaticRecharge'" class="automatic_recharge">
      <div>
        <label>当前充值账户：</label>
        <span class="fcDel">{{accountMsg.AgentName}}</span>
        <!--<span class="fcDel">（红色字体展示自动带出当前登录账号所属分销商名称，提交充值申请时要再次验证当前带出的这个账号是否与提交时的登录账号是否一致，一致时才允许提交充值）</span>-->
      </div>
      <div>
        <label>支付宝交易单号：</label>
        <input type="text" title="支付宝交易单号" maxlength="50" v-model.trim="alipayBusinessNum">
      </div>
      <div>
        <label>充值金额：</label>
        <input type="text" title="充值金额" maxlength="20" v-model.number="transactionAmount" @input="judgeNum()">
      </div>
      <div class="recharge_explain">
        <p class="fwb mb10">自动充值说明：</p>
        <p class="mb10">1.请用支付宝转账到 <span class="fcDel">【{{accountMsg.Account}}】</span>,姓名校验 <span class="fcDel">【{{accountMsg.AccountName}}】</span></p>
        <div class="vertical_center mb10">
          2.直接使用支付宝扫码支付。
          <!--<img src="../../../assets/img/bg_login.jpg" height="150" width="150" title="假的"/>-->
          <img :src="accountMsg.QRCodeImg" height="150" width="150" title="收款二维码"/>
        </div>
        <p class="mb10">3.转账成功后在支付宝-我的账单-中点击该笔交易，进入详细页面获取以年份开头(比如2019)的交易单号。</p>
        <p class="mb10">4.在上面*对应的输入框中输入支付宝交易单号及充值金额，点击【提交充值申请】按钮。</p>
        <p class="mb10">5.同一个支付宝交易订单号只能充值一次。</p>
        <p>6.转账后，请在48小时内充值完毕，否则将无法自动充值。</p>
      </div>

      <button class="btn_normal mt20" @click="saveRechargeWorkOrder()" :disabled="!accountMsg.AccountId">提交充值申请</button>
    </div>

    <div v-if="alipayType === 'manualRecharge'" class="manual_recharge">
      <div class="bank_information">
        <h6>平台收款银行账号信息：</h6>
        <p>银行账号开户行：{{accountMsg.AccountBank}}</p>
        <p>银行账号：{{accountMsg.Account}}</p>
        <p>账户所属人姓名：{{accountMsg.AccountName}}</p>
      </div>
     <!-- <div class="">
        <span>支付方式：</span>
        <input type="radio" id="alipay_recharge" name="manual_recharge_type" value="alipayRecharge" v-model="manualRechargeType"> <label for="alipay_recharge">支付宝</label>
        <input type="radio" id="bank_card" name="manual_recharge_type" value="bankCard" v-model="manualRechargeType"> <label for="bank_card">银行卡</label>
      </div> -->
      <div>
        <label>当前充值账户：</label>
        <span class="fcDel">{{accountMsg.AgentName}}</span>
      </div>
      <div>
        <label>转账交易单号：</label>
        <input type="text" title="转账交易单号" maxlength="50" v-model.trim="transferBillNumber">
      </div>
      <div>
        <label>充值金额：</label>
        <input type="text" title="充值金额" maxlength="20" v-model.number="transactionAmount">
      </div>
      <div class="recharge_explain">
        <p class="fwb mb10">手工充值说明：</p>
        <p class="mb10">1.手工充值，支持银行卡转账或支付宝转账操作。</p>
        <p class="mb10">2.请认真确认平台收款银行账号信息，完成转账操作。</p>
        <p class="mb10">3.转账时可以进行相关备注。转账完成后，填写此申请。付款人姓名，请正确填写。</p>
        <p>4.银行转账的请截图给财务QQ:{{customerServiceQQ}} 以方便审核。</p>
      </div>

      <button class="btn_normal mt20" @click="saveRechargeWorkOrder()" :disabled="!accountMsg.AccountId">提交充值申请</button>
    </div>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script type="es6">
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'account-recharge',
    components: {LoadingDialog, MsgDialog},
    data() {
      return {
        accountMsg: {
          AType: null, // 充值类型
          AccountId: null, // 转账账号ID
          Account: null, // 账号
          AccountName: '', // 账户
          AccountBank: '', // 账户银行
          QRCodeImg: '', // 收款二维码
          AgentBalance: '', // 余额
          AgentName: '' // 账户名
        }, // 账户信息
        alipayBusinessNum: null, // 支付宝交易单号
        transactionAmount: null, // 交易金额
        transferBillNumber: null, // 转账交易单号
        alipayType: 'automaticRecharge', // 充值类型：automaticRecharge = 支付宝自动充值   manualRecharge = 银行卡手动充值
        manualRechargeType: 'bankCard', // 手动充值类型：alipayRecharge = 支付宝 bankCard = 银行卡
        customerServiceQQ: sessionStorage.getItem('financeQQ'),
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 10 // 总条数
        }
      },
    methods: {
      // 充值类型切换
      exchangeAlipayType(type) {
        this.alipayType = type;
        this.getFundAccountList();
      },

      // 获取平台端账户充值数据
      getFundAccountList() {
        let type = 1; // 1=取平台支付宝收款信息，2=取平台银行卡收款信息
        if (this.alipayType === 'automaticRecharge') {
          type = 1;
        } else {
          type = 2;
        }
        this.$axios.get(this.Global.getFundAccountList(type)).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res) {
              if (!res.data.errorMsg.length) {
                self.accountMsg = res.data.resData;
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 判断是否为数字
      judgeNum() {
        if (typeof this.transactionAmount === 'string') {
          this.transactionAmount = null;
        }
      },

      // 提交充值申请
      saveRechargeWorkOrder() {
        let payN0 = null; // 交易单号
        let alipayType = 1; // 支付方式
        if (this.alipayType === 'automaticRecharge') {
          alipayType = 1;
          if (!this.alipayBusinessNum) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请填写交易单号';
            return;
          } else {
            payN0 = this.alipayBusinessNum;
          }
        } else if (this.alipayType === 'manualRecharge') {
          if (!this.transferBillNumber) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请填写交易单号';
            return;
          } else {
            payN0 = this.transferBillNumber;
          }
          if (!this.manualRechargeType) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择一种支付方式';
            return;
          }
          if (this.manualRechargeType === 'alipayRecharge') {
            alipayType = 1;
          } else {
            alipayType = 2;
          }
        }
        if (!this.transactionAmount) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写充值金额';
          return;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        this.$axios.get(this.Global.saveRechargeWorkOrder(payN0, this.transactionAmount, this.accountMsg.AccountId, alipayType, this.accountMsg.AgentName)).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '操作成功';
                self.alipayBusinessNum = null;
                self.transactionAmount = null;
                self.transferBillNumber = null;
                self.transactionAmount = null;
                self.getFundAccountList();
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getFundAccountList();
    },
    activated() {
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.alipayBusinessNum = null;
        this.transactionAmount = null;
        this.transferBillNumber = null;
        this.transactionAmount = null;
        this.getFundAccountList();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/base-color";

  .account_recharge {
    width: calc(100% - 20px);
    height: calc(100% - 40px);
    background-color: $cfff;
    overflow-y: auto;
    padding: 20px 10px;

    .exchange_recharge {
      /*width: 100%;*/
      height: 37px;
      line-height: 37px;

      li {
        float: left;
        height: 35px;
        line-height: 35px;
        padding: 0 30px;
        border: 1px solid #ddd;

        &.active {
          background-color: #dddddd;
        }

        &:hover {
          cursor: pointer;
        }
      }
    }

    .automatic_recharge {
      input[type='text'] {
        width: 350px;
      }

      & > div {
        margin-bottom: 10px;
      }

      .vertical_center {
        display: flex;
        align-items: center;
      }
    }

    .manual_recharge {
      position: relative;

      input[type='text'] {
        width: 350px;
      }

      input[type='radio'] {
        &:hover {
          cursor: pointer;
        }
      }

      & > div {
        margin-bottom: 10px;
      }

      .bank_information {
        position: absolute;
        min-width: 350px;
        left: 600px;
        border: 1px solid #000;
        line-height: 30px;
        padding: 10px 5px 10px 10px;
        border-radius: 25px;
      }
    }

    .recharge_explain {
      border: 1px solid;
      padding: 10px;
      width: max-content;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/money-management/account-recharge.vue